import {localStorageService} from "../storage/local-storage";
import storageKeys from "../storage/storageKeys";

const REQUIRED_CLICKS = 10;
const WINDOW_MS = 15_000;

let clicks: number[] = [];

export const socialSignInUnlock = {
  isEnabled(): boolean {
    return localStorageService.getItem(storageKeys.socialSignIn_isEnabled) === "1";
  },

  setEnabled(value: boolean): void {
    if (value) {
      localStorageService.setItem(storageKeys.socialSignIn_isEnabled, "1");
    } else {
      localStorageService.removeItem(storageKeys.socialSignIn_isEnabled);
    }
  },

  /**
   * Record a tap and return true when the tap completes a 10-in-15s burst,
   * toggling the persisted flag as a side effect.
   */
  recordClick(now: number = Date.now()): boolean {
    clicks.push(now);
    clicks = clicks.filter((t) => now - t < WINDOW_MS);

    if (clicks.length >= REQUIRED_CLICKS) {
      clicks = [];
      const newState = !socialSignInUnlock.isEnabled();
      socialSignInUnlock.setEnabled(newState);
      return true;
    }

    return false;
  },

  /** @internal test-only — reset in-memory click history */
  _resetClicks(): void {
    clicks = [];
  },
};
